import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import entryActions from '../entry-actions';
import MonthlyReportModal from '../components/MonthlyReportModal';
import selectors from '../selectors';
import ModalTypes from '../constants/ModalTypes';

const makeMapStateToProps = () => {
  const selectUnclosedCardPointDataForListAndCurrentMonth = selectors.makeSelectUnclosedCardPointDataForListAndCurrentMonth();
  const selectUnclosedCardPointDataForListAndMonth = selectors.makeSelectUnclosedCardPointDataForListAndMonth();
  const selectAllUnclosedCardPointDataForList = selectors.makeSelectAllUnclosedCardPointDataForList();
  const selectListById = selectors.makeSelectListById();
  const selectPointSystemByBoardId = selectors.makeSelectPointSystemByBoardId();
  const selectContentViewPlansByPointSystemId = selectors.makeSelectContentViewPlansByPointSystemId();
  const selectListReportDataByListId = selectors.makeSelectListReportDataByListId();
  const selectEmployeePlansByPointSystemId = selectors.makeSelectEmployeePlansByPointSystemId();
  return (state) => {
    const currentModal = selectors.selectCurrentModal(state);
    const listId = selectors.selectCurrentModalData(state)?.listId || null;
    
    // Получаем список для определения boardId
    const list = listId ? selectListById(state, listId) : null;
    const boardId = list?.boardId || selectors.selectPath(state).boardId;
    
    // Получаем PointSystem по boardId (из списка или текущей доски)
    const pointSystem = boardId ? selectPointSystemByBoardId(state, boardId) : null;
    
    const listReportData = listId
      ? selectListReportDataByListId(state, listId)
      : null;

    // Получаем незакрытые задачи для выбранного месяца
    // Используем year и month из listReportData или из report
    const report = selectors.selectMonthlyReport(state);
    const selectedYear = listReportData?.year || report?.year;
    const selectedMonth = listReportData?.month || report?.month;
    
    let unclosedTasks = [];
    if (pointSystem?.isEnabled && listId) {
      if (selectedYear && selectedMonth) {
        unclosedTasks = selectUnclosedCardPointDataForListAndMonth(
          state,
          listId,
          pointSystem.id,
          selectedYear,
          selectedMonth
        );
      } else {
        // Если год и месяц не выбраны, используем текущий месяц
        unclosedTasks = selectUnclosedCardPointDataForListAndCurrentMonth(state, listId, pointSystem.id);
      }
    }

    // Получаем все незакрытые задачи в списке (для секции "Незакрытые задачи в списке")
    // Без фильтрации по году/месяцу
    let allUnclosedTasksInList = [];
    if (pointSystem?.isEnabled && listId) {
      allUnclosedTasksInList = selectAllUnclosedCardPointDataForList(state, listId, pointSystem.id);
    }

    const contentViewPlans = pointSystem
      ? selectContentViewPlansByPointSystemId(state, pointSystem.id)
      : [];

    const employeePlans = pointSystem
      ? selectEmployeePlansByPointSystemId(state, pointSystem.id)
      : [];

    return {
      open: currentModal === ModalTypes.MONTHLY_REPORT,
      pointSystem,
      report: selectors.selectMonthlyReport(state),
      isReportLoading: selectors.selectMonthlyReportIsLoading(state),
      listId,
      unclosedTasks,
      allUnclosedTasksInList,
      contentViewPlans,
      listReportData,
      employeePlans,
    };
  };
};

  const mapDispatchToProps = (dispatch) => {
  const boundActions = bindActionCreators(
    {
      onClose: entryActions.closeModal,
      onReportFetch: entryActions.fetchMonthlyReportInCurrentBoard,
      onContentViewPlansFetch: entryActions.fetchContentViewPlansInCurrentBoard,
      onEmployeePlansFetch: entryActions.fetchEmployeePlansInCurrentBoard,
      onDampingCoefficientsFetch: entryActions.fetchDampingCoefficientsInCurrentBoard,
      onOpenUnclosedTasksModal: entryActions.openUnclosedTasksModal,
      onListReportDataFetch: entryActions.fetchListReportDataInCurrentList,
      onListReportDataUpsert: entryActions.upsertListReportDataInCurrentList,
      onListReportDataComplete: entryActions.completeListReportDataInCurrentList,
    },
    dispatch,
  );

  return {
    ...boundActions,
    onCompleteMonth: () => {
      boundActions.onListReportDataComplete();
    },
  };
};

export default connect(makeMapStateToProps, mapDispatchToProps)(MonthlyReportModal);

